import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HCMore from "highcharts/highcharts-more";

if (typeof Highcharts === "object") {
  HCMore(Highcharts);
}

const BoxPlotLog = () => {
  const rawData = {
    27447: [
      1725.56, 898.73, 56.0, 11284.0, 842.0, 0.0, 5695.0, 875.0, 18010.1,
      12519.34, 14728.63, 15465.06, 4315.49, 3041.53, 11270.0, 8664.88, 3837.3,
      4792.34, 5852.19, 4350.37, 4221.57, 75.0, 23175.0, 41574.0, 4809.15,
      10814.0, 530.0, 49999.5, 9616.11, 42.4, 16721.38, 3729.88, 143.8, 947.0,
      11736.0, 20323.0, 12404.08, 2199.0, 2000.0, 11157.5, 2765.03, 13806.0,
      17045.0, 13905.0, 9241.0, 24000.0, 10381.5, 4532.69, 14200.0, 725.0,
      5836.35, 11000.0, 20070.5, 14921.05, 31698.0, 1473.71, 1222.27, 1294.17,
      11219.0, 908.0, 3627.0, 3191.76, 688.0, 20972.0, 19500.0, 15000.0,
      21225.0, 13292.0, 3459.74, 5230.9, 4160.01, 28825.0, 52000.0, 32210.0,
      5843.0, 934.0, 12000.0, 995.0, 11943.84, 12862.6, 4238.5, 1453.24,
      20921.27, 15187.4, 10000.0, 5197.0, 10500.0, 20119.33, 3737.83, 5233.2,
      70.0, 50089.0, 37385.0, 41647.0, 80.0, 9661.0, 12734.0, 13087.0, 16000.0,
      915.0, 714.0, 655.0,
    ],
    66984: [
      4829.0, 541.56, 722.08, 5217.0, 1071.61, 6133.0, 49999.5, 1000.0, 1167.0,
      1673.49, 1124.09, 995.0, 1119.22, 7062.0, 5033.0, 7185.0, 980.44, 3245.0,
      1983.9, 2894.0, 1347.0, 1040.0, 1603.19, 1344.4, 1222.18, 1002.0, 3830.01,
      1388.7, 1101.5, 1553.94, 6132.62, 2291.0, 2062.0, 2353.27, 1366.32,
      376.08, 511.47, 60.17, 9510.0, 7990.0, 4336.0, 5442.0, 1396.0, 6300.0,
      1456.0, 1332.0, 1627.38, 1376.0, 1256.23, 4588.78, 1922.93, 1529.26,
      1345.1, 1104.4, 1563.0, 1928.39, 4481.0, 1232.71, 2131.43, 1600.0, 1697.0,
      1174.0, 843.0, 1357.27, 3567.0, 926.0, 1686.32, 9452.0, 9256.0, 1137.23,
      1907.51, 1465.0, 2043.05, 1625.0, 2455.0, 1403.3, 3087.29, 1344.16,
      1873.53, 1742.87, 1325.0, 957.0, 1445.81, 1410.81, 1345.19, 925.0,
      2123.32, 941.96, 1873.0, 3409.18, 956.0, 1407.21, 1422.0, 2160.0, 602.32,
      0.0, 1097.0, 1633.95, 3819.0, 928.0, 4911.0, 918.0, 9907.0, 6909.0,
      1346.0, 1652.18, 1770.64, 1197.0, 1168.83, 1128.0, 1051.0, 1107.0, 1137.2,
      1069.72, 2592.9, 15000.0, 12450.0, 1086.0, 2744.81, 1376.56,
    ],
    70450: [
      640.01, 12.15, 519.0, 874.18, 164.63, 1075.0, 420.26, 183.55, 73.26,
      239.0, 466.63, 455.25, 411.49, 339.33, 786.63, 394.94, 359.23, 301.53,
      250.0, 725.0, 274.73, 148.86, 173.31, 304.05, 244.12, 190.49, 200.02,
      561.84, 205.45, 179.89, 176.43, 275.0, 578.7, 350.45, 327.41, 551.56, 1,
      131.07, 727.0, 6, 162.0, 26.0, 270.32, 409.85, 548.74, 188.47, 213.66,
      309.61, 345.98, 1, 469.71, 689.64, 299.21, 269.46, 432.91, 222.0, 76.0,
      299.7, 55.54, 218.83, 305.96, 269.07, 222.1, 306.42, 660.0, 326.66,
      221.59, 304.39, 701.78, 498.8, 205.14, 306.33, 159.11, 2, 524.0, 557.11,
      459.06, 297.81, 282.58, 505.59, 125.34, 167.93, 208.7, 285.37, 280.19,
      135.67, 251.02, 1, 623.74, 75.96, 103.31, 121.54, 459.0, 68.91, 68.4,
      377.66, 1, 362.77, 140.03, 929.13, 117.28, 56.6, 338.63, 769.62, 942.47,
      314.09, 219.7, 348.36, 367.78, 324.27, 539.49, 516.74, 139.88, 161.47,
      137.39, 161.54, 119.13, 246.83, 220.83, 328.26, 234.07, 199.58, 1082.0,
      49, 999.5, 331.19, 574.21, 695.73, 269.37, 234.51, 329.27, 415.03, 62.27,
      756.65, 2, 128.0, 293.0, 310.3, 381.16, 800.0, 276.72, 281.31, 275.8,
      459.92, 416.5, 347.0, 1, 633.01, 378.36, 183.99, 177.72, 154.02, 220.23,
      167.04, 307.79, 284.49, 175.1, 199.89, 211.9, 138.77, 782.24, 307.89,
      220.75, 205.68, 235.38, 304.75, 71.0, 133.59, 224.17, 241.8, 326.15,
      306.1, 156.6, 539.0, 386.87, 263.0, 151.15, 84.21, 392.2, 311.33, 145.85,
      350.0, 490.42, 500.0, 129.17, 143.52, 110.13, 110.6, 217.87, 280.22,
      475.09, 391.77, 435.06, 438.68, 276.26, 226.23, 223.4, 217.15, 168.32, 1,
      184.73, 57.52, 595.14, 513.46, 306.84, 306.0, 707.42, 158.02, 297.53,
      478.83, 57.7, 506.76, 365.35, 450.0, 1065.0, 1055.0, 176.7, 214.07,
      272.37, 169.85, 28.7, 24.9, 299.15, 392.0, 91.42, 3, 138.0, 414.12,
      169.62, 179.45, 1, 300.0, 442.27, 200.09, 265.18, 241.07, 239.95, 199.16,
      206.9, 307.48, 363.16, 203.98, 58.93, 301.91, 221.76, 272.61, 218.89,
      301.99, 220.63, 304.56, 702.33, 86.4, 2, 163.0, 2, 162.0, 3, 329.0, 93.05,
      403.03, 83.84, 576.88, 311.63, 406.27, 209.5, 400.0, 198.73, 84.02,
      188.99, 171.41, 276.12, 109.39, 596.0, 132.36, 176.21, 414.0, 474.88, 1,
      246.95, 1, 467.0, 2069.0, 136.11, 146.36, 118.06, 105.55, 0.0, 307.65,
      66.6, 382.67, 666.6, 531.28, 319.52, 533.0, 383.25, 285.22, 226.83,
      255.63, 252.0, 298.0, 1, 173.0, 142.95, 64.54, 367.53, 600.0, 156.1,
      193.48, 135.12, 228.08, 128.19, 854.7, 240.94, 610.26, 1, 313.5, 289.76,
      2, 554.51, 146.07, 787.09, 129.92, 541.0, 312.17, 403.77, 540.75, 65.0,
      391.08, 370.0, 234.54, 269.5, 620.68, 183.65, 199.22, 140.79, 198.03,
      133.49, 691.89, 589.04, 162.17, 310.79, 79.11, 339.93, 168.01, 66.31,
      269.0, 271.21, 575.0, 525.0, 1, 231.0, 154.6, 62.0, 430.96, 653.0, 338.0,
      267.0, 2, 740.0, 2, 882.0, 328.42, 332.1, 187.19, 192.8, 436.59, 529.84,
      813.51, 674.0, 237.87, 309.23, 229.92, 282.33, 150.91, 122.35, 1000.0,
      262.71, 384.79, 338.61, 149.3, 1022.98,
    ],
    74177: [
      417.86, 810.49, 186.74, 1295.0, 1246.95, 1536.26, 2474.58, 788.34, 688.84,
      808.16, 888.98, 1626.39, 1040.77, 1522.7, 316.26, 977.65, 539.0, 666.6,
      5398.0, 459.0, 624.48, 1027.15, 213.81, 503.51, 624.89, 684.98, 26.0,
      1347.54, 653.08, 2128.0, 556.59, 417.0, 1000.0, 279.11, 406.52, 490.22,
      872.73, 1255.03, 616.93, 520.32, 600.37, 462.76, 2006.81, 258.3, 426.06,
      369.23, 1085.44, 675.21, 675.02, 829.78, 684.07, 840.91, 945.23, 505.75,
      65.0, 834.82, 733.89, 3898.94, 874.18, 879.43, 930.14, 49999.5, 1206.0,
      683.55, 939.49, 832.07, 5668.0, 1353.27, 944.24, 541.0, 370.0, 428.63,
      484.24, 748.83, 222.0, 843.62, 751.63, 208.11, 381.0, 723.21, 1184.73,
      2149.39, 1368.17, 1088.07, 547.74, 946.53, 391.08, 1363.04, 3329.0,
      2524.0, 397.23, 34.82, 217.64, 313.4, 856.0, 310.72, 1070.25, 1097.0,
      564.47, 1699.14, 463.0, 509.93, 667.02, 1141.64, 660.95, 86.4, 585.0,
      1034.99, 769.62, 1137.86, 1003.67, 920.57, 1120.8, 2427.99, 264.25,
      1923.54, 476.72, 1191.26, 468.79, 656.13, 529.91, 809.49, 975.57, 66.6,
      56.6, 591.71, 414.0, 635.23, 2583.13, 2108.38, 2110.01, 800.0, 888.61,
      1173.0, 607.1, 2070.84, 451.85, 511.97, 410.26, 412.99, 5449.0, 685.11,
      836.61, 4241.64, 948.66, 1290.05, 250.0, 338.89, 948.48, 958.71, 877.57,
      938.96, 949.78, 827.95, 525.93, 1547.55, 698.15, 432.36, 952.77, 298.0,
      358.7, 267.0, 924.48, 1485.58, 600.0, 500.0, 3048.0, 351.0, 4907.56,
      1605.08, 60.0, 525.0, 956.8, 559.34, 681.21, 1142.66, 416.5, 2003.16,
      1124.28, 2740.0, 295.99, 919.99, 1467.0, 1384.14, 803.64, 770.09, 1005.01,
      0.0, 619.33, 1128.74, 435.67, 685.04, 1263.88, 651.79, 632.99, 904.91,
      660.0, 519.0, 596.0, 226.02, 961.13, 1255.71, 1111.27, 1850.0, 820.44,
      390.7, 669.88, 367.7, 1108.6, 703.5, 552.82, 654.29, 2541.11, 496.14,
      1282.9, 653.0, 596.66, 674.62, 1185.36, 1628.97, 502.05, 476.13, 774.86,
      931.56, 691.51, 929.33, 566.44, 3138.0, 237.29, 1018.62, 408.24, 680.95,
      459.08, 1807.57, 763.76, 1796.1, 1040.59, 706.63, 468.0, 338.0, 232.46,
      400.0, 1063.73, 331.15, 491.1, 671.25, 1075.0, 486.48, 727.0, 1101.4,
      795.53, 1257.86, 1526.53, 818.79, 57.52, 518.2, 350.0, 1067.77, 1242.42,
      724.78, 663.74, 442.27, 2163.0,
    ],
    99283: [
      70.8, 2059.0, 2472.0, 2500.0, 206.47, 1912.0, 3333.0, 2015.0, 5955.0,
      6224.0, 6584.0, 1600.0, 1167.0, 800.0, 638.0, 860.0, 400.0, 794.0, 853.0,
      596.0, 1475.0, 1245.0, 2769.22, 909.0, 818.0, 1098.0, 4205.0, 993.0,
      600.0, 917.0, 950.0, 949.0, 10775.0, 782.0, 2502.0, 3171.0, 1855.0,
      6180.0, 1465.0, 1967.0, 1523.0, 1789.0, 1853.0, 1258.0, 1598.0, 2715.0,
      1996.0, 1232.0, 2364.0, 2627.0, 530.0, 3051.0, 1277.0, 2962.0, 1438.96,
      2182.0, 710.0, 2311.0, 2902.0, 1705.0, 1133.0, 66.0, 2000.0, 65.0, 339.7,
      703.0, 2785.0, 4876.0, 1790.72, 1606.94, 1125.0, 1202.08, 894.0, 590.0,
      562.0, 1150.0, 1484.0, 1638.0, 450.0, 300.0, 456.0, 888.0, 783.0, 1477.0,
      472.0, 1586.0, 1732.0, 2232.0, 2188.0, 2160.0, 1009.0, 2315.0, 3031.0,
      125.0, 805.0, 780.0, 2464.0, 1734.0, 1159.0, 1449.0, 2507.0, 819.0,
      4487.0, 1273.0, 131.88, 67.4, 1231.0, 471.0, 640.0, 83.04, 1088.0,
      1322.57, 1214.0, 2389.0, 2900.0, 3531.0, 861.0, 2675.0, 1226.0, 1902.0,
      3095.0, 364.7, 3012.0, 2550.0, 2677.0, 1012.2, 1591.0, 326.0, 250.91,
      133.97, 479.65, 191.52, 763.34, 732.0, 712.0, 2118.0, 1540.0, 1056.0,
      1173.0, 289.56, 2096.73, 1730.0, 1583.55, 1047.0, 804.0, 842.78,
    ],
  };

  const getBoxStats = (arr) => {
    const sorted = arr
      .filter((v) => !isNaN(v) && v > 0 && isFinite(v))
      .sort((a, b) => a - b);

    if (sorted.length === 0) return [0, 0, 0, 0, 0];

    const q1Index = Math.floor(sorted.length * 0.25);
    const medianIndex = Math.floor(sorted.length * 0.5);
    const q3Index = Math.floor(sorted.length * 0.75);

    return [
      sorted[0], // min (lower whisker)
      sorted[q1Index], // Q1
      sorted[medianIndex], // median
      sorted[q3Index], // Q3
      sorted[sorted.length - 1], // max (upper whisker)
    ];
  };

  const boxData = Object.keys(rawData).map((code) =>
    getBoxStats(rawData[code])
  );

  const categories = Object.keys(rawData);

  // Correct outlier detection using IQR method
  const outliers = Object.keys(rawData).flatMap((code, i) => {
    const [min, q1, median, q3, max] = boxData[i];
    const data = rawData[code].filter((v) => !isNaN(v) && v > 0 && isFinite(v));

    // Calculate IQR and bounds for outliers
    const iqr = q3 - q1;
    const lowerBound = q1 - 1.5 * iqr;
    const upperBound = q3 + 1.5 * iqr;

    return data
      .filter((v) => v < lowerBound || v > upperBound)
      .map((v) => [i, v]);
  });

  // Different colors for each box
  const boxColors = [
    "#A8D8EA", // Soft sky blue (calm, trust)
    "#98D8AA", // Mint green (health, freshness)
    "#86C7CC", // Seafoam teal (balance, healing)
    "#B5EAD7", // Pale aqua (renewal, clean)
    "#9ACEEB", // Light cornflower (professional, serene)
    "#C7E9C0", // Celadon green (growth, wellness)
  ];
  const options = {
    chart: {
      type: "boxplot",
      backgroundColor: "#FFFFFF",
      height: 600,
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Box Plot Distribution",
      style: {
        color: "#1E293B",
        fontSize: "24px",
        fontWeight: "700",
        fontFamily: "'Inter', sans-serif",
      },
    },
    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },
    xAxis: {
      categories: categories,
      title: {
        text: "Billing Codes",
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      title: {
        text: "Negotiated Rate($) ",
      },
      labels: {
        formatter: function () {
          return "$" + this.value.toLocaleString();
        },
      },
      minorTickInterval: 0.1,
    },
    plotOptions: {
      boxplot: {
        fillColor: "#F8FAFC",
        lineWidth: 3,
        medianColor: "#000000",
        medianWidth: 0.8,
        stemColor: "#8f97a2",
        stemDashStyle: "Solid",
        stemWidth: 1.5,
        whiskerColor: "#8f97a2",
        whiskerLength: "80%",
        whiskerWidth: 2,
        pointWidth: 50,
      },
      scatter: {
        marker: {
          radius: 4,
          symbol: "circle",
        },
      },
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "rgba(255, 255, 255, 0.98)",
      borderColor: "#E2E8F0",
      borderRadius: 8,
      borderWidth: 1,
      shadow: false,
      padding: 12,
      style: {
        color: "#1E293B",
        fontSize: "12px",
        fontFamily: "'Inter', sans-serif",
      },
      headerFormat:
        '<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid {series.color}20;">' +
        '<div style="width: 12px; height: 12px; border-radius: 50%; background: {series.color};"></div>' +
        '<span style="font-weight: 600; font-size: 13px;">{series.name}</span>' +
        "</div>",
      pointFormatter: function () {
        // Format all numbers with commas and 2 decimals
        const format = (val) => Highcharts.numberFormat(val, 2, ".", ",");
        return `
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px 12px;">
            <div style="color: #64748B;">Min</div><div><b>$${format(
              this.low
            )}</b></div>
            <div style="color: #64748B;">Q1</div><div><b>$${format(
              this.q1
            )}</b></div>
            <div style="color: #64748B;">Median</div><div><b>$${format(
              this.median
            )}</b></div>
            <div style="color: #64748B;">Q3</div><div><b>$${format(
              this.q3
            )}</b></div>
            <div style="color: #64748B;">Max</div><div><b>$${format(
              this.high
            )}</b></div>
          </div>
        `;
      },
    },

    series: [
      {
        name: "",
        data: boxData.map((data, index) => ({
          low: data[0],
          q1: data[1],
          median: data[2],
          q3: data[3],
          high: data[4],
          color: boxColors[index % boxColors.length],
          fillColor: boxColors[index % boxColors.length],
        })),
        tooltip: {
          headerFormat: "",
        },
      },
      {
        name: "",
        type: "scatter",
        data: outliers,
        marker: {
          radius: 3,
          symbol: "circle",
          lineColor: "#FD444d",
          lineWidth: 1,
          fillColor: "#FDA4AF",
        },
        tooltip: {
          pointFormatter: function() {
              const format = (val) => Highcharts.numberFormat(val, 2, ".", ",");
              return `Outlier: <b>$${format(this.y)}</b>`;
          },
          headerFormat: "",
      }
      
      
      },
    ],
  };

  return (
    <div
      className="p-6 border-1"
      style={{ width: "97%", margin: "auto", borderRadius: "12px" }}
    >
      <div className="bg-white rounded-2 border border-gray-200 p-4">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  );
};

export default BoxPlotLog;
